module.exports = __webpack_public_path__ + "media/images/lock 1-c08990b7.svg";